<template>
    <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
        <v-toolbar elevation="0">
            <v-text-field
                    flat
                    solo
                    prepend-icon="search"
                    placeholder="Type something"
                    v-model="search"
                    hide-details
                    class="hidden-sm-and-down"
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="mt-6">
                <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="opsitable.awal"
                                label="Tanggal Awal"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="opsitable.awal" @input="menu1 = false"></v-date-picker>
                </v-menu>
            </div>
            <div class="mt-6">
                <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="opsitable.akhir"
                                label="Tanggal Akhir"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="opsitable.akhir" @input="menu2 = false"></v-date-picker>
                </v-menu>
            </div>
            <v-btn class="ml-2" color="primary" @click.native="getContracts(opsitable)">
                <v-icon dark>refresh</v-icon>Refresh
            </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table
                :headers="headers"
                :search="search"
                :items="contract"
                class="elevation-0"
                item-key="id"
                :options.sync="opsitable"
                :server-items-length="total_contract"
                :loading="loading"
                @update:options="getContracts(opsitable)"
        >
            <template v-slot:item.amount="{ item }">
                <div class="">
                    {{formatAngka(item.amount)}}
                </div>
            </template>
            <template v-slot:item.fee="{ item }">
                <div class="">
                    {{formatAngka(item.fee)}}
                </div>
            </template>
            <template v-slot:item.created="{ item }">
                {{formatDate(item.created)}}
            </template>
            <template v-slot:item.status="{ item }">
                <div class="ma-4 text-xs-left">
                    <v-chip
                            v-if="item.status===1"
                            color="green"
                            small
                            text-color="white"
                    >{{ statustext(item.status) }}</v-chip>
                    <v-chip
                            v-else
                            color="deep-orange"
                            small
                            text-color="white"
                    >{{ statustext(item.status) }}</v-chip>
                </div>
            </template>
            <template v-slot:item.action="{ item }">

                <div v-if="item.status===0" class="ma-4 text-xs-left">
                    <v-btn text @click.native="confmPayment(item)" class="primary">
                       BAYAR
                    </v-btn>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import moment from "moment";
    import {mapActions, mapState} from "vuex";
    import Utils from "@/plugins/utils";

    export default {
        name: "ListPencairan",
        data: ()=>({
            search: '',
            menu1: false,
            menu2: false,
            dateawal: moment().add(7,'hours').toISOString().substr(0, 10),
            dateakhir: moment().add(7,'hours').toISOString().substr(0, 10),
            contractno:'',
            opsitable: {
                search:'',
                itemsPerPage: 10,
                page:1,
                sortBy: ["id"],
                awal: moment().add(7,'hours').toISOString().substr(0, 10),
                akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            },
            headers: [
                {
                    text: 'id',
                    value: 'id'
                },
                {
                    text: 'No',
                    value: 'contractno'
                },
                {
                    text: 'Time ',
                    value: 'created'
                },
                {
                    text: 'Amount',
                    value: 'amount'
                },
                {
                    text: 'Fee (Biaya)',
                    value: 'fee'
                },
                {
                    text: 'Jauh Tempo',
                    value: 'duedate'
                },
                {
                    text: 'Status',
                    value: 'status'
                },
                {
                    text: 'Actions',
                    value: 'action'
                },

            ],
        }),
        mounted(){
            this.getContracts(this.opsitable);
        },
        computed: {
            ...mapState('Loan',['contract','loading','total_contract'])
        },
        methods: {
            ...mapActions('Loan',['getContracts','doRepayment']),
            formatAngka(val){
                return Utils.formatAngka(val)
            },
            formatDate (value) {
                return moment(value).add(7,'hours').format("YYYY-MM-DD HH:mm:ss")
            },
            confmPayment (data) {
                console.log(data);
                this.contractno = data.contractno
                this.$confirm('Yakin akan Bayar Contract:'+this.contractno + ' ?', { color: 'green',title:'Konfirmasi',icon:'fa-question' }).then(res => {
                    if (res) {
                        this.doRepayment({contractno:this.contractno})
                    }
                })
            },
            statustext(val){
                if(val===0){
                    return "Belum terbayar";
                }
                if(val===1){
                    return "Lunas";
                }
            }
        }
    }
</script>

<style scoped>

</style>
